// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useEffect, useState } from 'react';
import newRankA from '../../../../assets/imgs/lotteryDetail/newRankA.png';
import newRankB from '../../../../assets/imgs/lotteryDetail/newRankB.png';
import newRankC from '../../../../assets/imgs/lotteryDetail/newRankC.png';
import newRankD from '../../../../assets/imgs/lotteryDetail/newRankD.png';
import newRankE from '../../../../assets/imgs/lotteryDetail/newRankE.png';
import prizeLeft from '../../../../assets/imgs/lotteryDetail/prize-left.png';
import prizeRight from '../../../../assets/imgs/lotteryDetail/prize-right.png';

export const StyledPrizeLeft = styled.div`
  background: url(${prizeLeft}) no-repeat;
  background-size: 100% 100%;
  margin-left: 5px;
  width: 100%;
  height: 80.26px;
  justify-content: start;
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    background-size: 99% 45px !important;
    width: 100%;
    height: 45px;
  }
`;
export const StyledPrizeRight = styled.div`
  background: url(${prizeRight}) no-repeat;
  background-size: 100% 100%;
  margin-right: 5px;
  width: 100%;
  height: 80.26px;
  justify-content: start;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: space-around;
`;
const StyledSpan = styled.span`
  font-size: ${(props) => (props.length ? 20 - props.length + 'px' : '20px')};
`;

const WidthLeft = styled.div`
  width: ${(props) => (props.isLength ? '60%' : '75%')};
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
const WidthRight = styled.div`
  width: ${(props) => (props.isLength ? '40%' : '35%')};
`;

import { useTranslation } from 'react-i18next';
import { setBackGroundLineUp } from '../../../utils/setBackGroundLineUp';
import { QUANTITY_PRIZE, RANK_A, RANK_B, RANK_C, RANK_D, RANK_E } from '../../../constants';
import styled from 'styled-components';
import { dottedLineupHeader } from '../../../../assets/imgs';

function LineUpHeader(props) {
  const { t } = useTranslation();
  const { prizeGroup, quantityPrize } = props;
  const [imageRank, setImageRank] = useState(newRankA);

  useEffect(() => {
    switch (prizeGroup.rank_name) {
      case RANK_A:
        setImageRank(newRankA);
        break;
      case RANK_B:
        setImageRank(newRankB);
        break;
      case RANK_C:
        setImageRank(newRankC);
        break;
      case RANK_D:
        setImageRank(newRankD);
        break;
      case RANK_E:
        setImageRank(newRankE);
        break;
    }
  }, [prizeGroup]);

  return (
    <div className={`my-line-up-header`}>
      <div className="my-line-up-content">
        <WidthLeft
          isLength={
            prizeGroup.total_quantity.toString().length +
              prizeGroup.total_begin_quantity.toString().length >
              10 && quantityPrize === QUANTITY_PRIZE.ACTIVE
          }
        >
          <div className="my-rank-name">
            <div className="logo-rank-name">
              <img src={imageRank} alt="rank" />
            </div>

            <div
              className={`wrap-title-prize ${setBackGroundLineUp(prizeGroup.rank_name).bgWinRate}`}
            >
              <div className="wrap-radius-prize"></div>
              <div
                className={`background-border ${
                  setBackGroundLineUp(prizeGroup.rank_name).bgWinRate
                }`}
              ></div>
              <div className="wrap-border"></div>
              <StyledPrizeLeft>
                <div className="title-prize text-center">
                  {prizeGroup.title}{' '}
                  {t('quantityPrize').replace('param', prizeGroup.quantity_prize)}
                </div>
              </StyledPrizeLeft>
            </div>
          </div>
        </WidthLeft>
        <WidthRight
          isLength={
            prizeGroup.total_quantity.toString().length +
              prizeGroup.total_begin_quantity.toString().length >
              10 && quantityPrize === QUANTITY_PRIZE.ACTIVE
          }
        >
          <div
            className={`line-up-win-rate ${setBackGroundLineUp(prizeGroup.rank_name).bgWinRate}`}
          >
            <div className="border-left-dotted">
              <img src={dottedLineupHeader} />
            </div>
            <StyledPrizeRight>
              <div className="win-rate-first">
                <div className="text">{t('winRate')}</div>
                <div className="win-rate-value">
                  {parseFloat(prizeGroup.win_rate).toFixed(2)}
                  <span>%</span>
                </div>
              </div>
              {quantityPrize === QUANTITY_PRIZE.ACTIVE && (
                <>
                  <div className="border-left"></div>
                  <div className="win-rate-second">
                    {prizeGroup.total_quantity > 0 ? (
                      <>
                        <div className="text">{t('winRate/100')}</div>
                        <div className="win-rate-value">
                          <StyledSpan length={prizeGroup.total_begin_quantity?.length || 0}>
                            <strong className="f-b">{prizeGroup.total_quantity} </strong>/{' '}
                            {prizeGroup.total_begin_quantity}
                          </StyledSpan>
                        </div>
                      </>
                    ) : (
                      <div className="win-rate-sold-out">SOLD OUT</div>
                    )}
                  </div>
                </>
              )}
              <div className="wrap-radius-prize-right rotate-180"></div>
            </StyledPrizeRight>
          </div>
        </WidthRight>
      </div>
    </div>
  );
}

export default LineUpHeader;
